import { useObserver } from 'mobx-react';

import useStores from '@stores/useStores';

export const useSignStore = () => {
  const { signStore } = useStores();

  return useObserver(() => ({
    captchaGet: signStore.captchaGet,
    imageBase64: signStore.image,
    captchaVerify: signStore.captchaVerify,
    idCaptcha: signStore.idCaptcha,
  }));
};
